import axios from "axios";
import {HOST_DEV} from "../common/constants";

const instance = axios.create({
    baseURL: HOST_DEV,
})


instance.interceptors.request.use(
    request => {

        request.headers.Authorization = `JWT ${localStorage.getItem('jwt')}`
        request.headers['Content-Type'] = 'multipart/form-data'

        return request
    },
    error => {
        console.log(error)
    }
);

export const skuFoodApi = {
    getData(offset: number, start_date_from: string, end_date_to: string, cities: string, store_name: string, ordering: string, address: string){
        return instance.get(`/skufood/?offset=${offset}&start_date_from=${start_date_from}&end_date_to=${end_date_to}&city=${cities}&store_name=${store_name}&ordering=${ordering}&address=${address}`)
    },

    getSkuFoodCategoryCount(start_date_from: string, end_date_to: string, cities: string, store_name: string, level_category: string){
        return instance.get(`/skufood-category-count/?start_date_from=${start_date_from}&end_date_to=${end_date_to}&city=${cities}&store_name=${store_name}&level_category=${level_category}`)
    },

    getSkuFoodCategory(start_date_from: string, end_date_to: string, cities: string, store_name: string,){
        return instance.get(`/skufood-category/?start_date_from=${start_date_from}&end_date_to=${end_date_to}&city=${cities}&store_name=${store_name}`)
    },

    getSkuFoodTotal(start_date_from: string, end_date_to: string, cities: string, store_name: string, address: string){
        return instance.get(`/skufood-total/?start_date_from=${start_date_from}&end_date_to=${end_date_to}&city=${cities}&store_name=${store_name}&address=${address}`)
    },
    getSkuFoodSvTable(start_date_from: string, end_date_to: string, cities: string, store_name: string,){
        return instance.get(`/svtable/?start_date_from=${start_date_from}&end_date_to=${end_date_to}&city=${cities}&store_name=${store_name}`)
    },
}